import { PermissionsConjunction } from 'frontend-container/components/Menu/authorization/types';
import { MenuElement } from 'frontend-container/components/Menu/types';

import { propertyPermissionKeys } from '@ac/library-api';
import { acConfig } from '@ac/library-utils/dist/declarations';
import { IconName } from '@ac/web-components';

const endOfDayViewPermission = propertyPermissionKeys.endOfDay.view;

export const endOfDayMenu: MenuElement = {
  translation: 'MENU.END_OF_DAY.TITLE',
  icon: IconName.audit,
  id: 'menu-end-of-day',
  items: [
    {
      link: `${acConfig.newFrontendUrls.cashiering}/end-of-day`,
      translation: 'MENU.END_OF_DAY.ITEMS.DASHBOARD',
      permissionsConfiguration: {
        permissions: [endOfDayViewPermission],
        permissionsConjunction: PermissionsConjunction.And,
      },
      keyboardShortcutWindows: 'alt+ctrl+e',
      keyboardShortcutMac: '⌥+⌘+e',
      keyCode: 69,
    },
    {
      link: `${acConfig.newFrontendUrls.cashiering}/end-of-day/logs`,
      translation: 'MENU.END_OF_DAY.ITEMS.LOGS',
      permissionsConfiguration: {
        permissions: [endOfDayViewPermission],
        permissionsConjunction: PermissionsConjunction.And,
      },
      keyboardShortcutWindows: 'alt+ctrl+f1',
      keyboardShortcutMac: '⌥+⌘+f1',
      keyCode: 112,
    },
  ],
};
